import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import JournalMonoHtmlView from './JournalHtml';
import JournalMonoReactView from './Journal';
const JournalMonoView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(JournalMonoHtmlView, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(JournalMonoReactView, _extends({}, props));
};
JournalMonoView.displayName = 'JournalMonoView';
export default JournalMonoView;
